<template>
  <div>
    <logo-with-image-editor v-if="isHotel" />
    <logo-editor v-else />
  </div>
</template>

<script>
  import LogoWithImageEditor from './LogoWithImageEditor.vue';
  import LogoEditor from './LogoEditor.vue';
  import accountProfileService from "root/v-components/account-profile/accountProfileService";

  export default {
    name: 'rbv-account-image-editors',
    components: { LogoWithImageEditor, LogoEditor },
    asyncComputed: {
      isHotel: {
        lazy: true,
        get() {
          return accountProfileService.getAccount()
            .then( a => a.type === 'HOTEL' )
        }
      }
    },
  }
</script>

<style lang="stylus" module></style>
